module.exports = __webpack_public_path__ + "img/AndorLandorIRL.82d6fd20.png";